import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form,Spinner, Input, FormFeedback, Label ,FormGroup, Button, CardTitle} from "reactstrap";
import Breadcrumb from '../Common/Breadcrumb';
import TableContainer from '../Common/TableContainer';
import Select from 'react-select'
import moment from 'moment';
import axios from '../../axios';
import numeral from "numeral"
import _ from 'lodash';
import SweetAlert from 'react-bootstrap-sweetalert';
import FileSaver from 'file-saver'
import Xl from 'excel4node'
import { Backdrop, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    display:'flex',
    flexDirection:'column',
  
  },
}));


const ShippedOrder=()=>{

    //date
    const [fromdate, setfromdate] = useState(new Date())
    const [todate, settodate] = useState(new Date())

    //table
     const[showTable,setshowTable]=useState(false)

    //shipmodevalue
    const [shipmodevalue,setshipmodevalue]=useState({label:"All", value:"All"})

    //ordertypevalue
    const[ordertypevalue,setordertypevalue]=useState({label:"All", value:"All"})

    //companyhelp
    const[companyhelp,setcompanyhelp]=useState([])
    const [Companyvalue, setCompanyvalue] = useState({})

    //buyerhelp
    const [buyerhelp,setbuyerhelp]=useState([])
    const[buyervalue,setbuyervalue]=useState({label:"All", value:"0"})

     //stylehelp
     const[stylehelp,setstylehelp]=useState([])
     const[stylevalue,setstylevalue]=useState({label:"All", value:"All"})

     //shippedorderdata
     const[shippedorderdata,setshippedorderdata]=useState([])

    //total sum
     const totalQty = _.sumBy(shippedorderdata, 'shipQty');
     const totalininr=_.sumBy(shippedorderdata,'valueinINR')

     //datanotfoundpopup
     const [notfoundpopup, setnotfoundpopup] = useState(false)

     const classes = useStyles();
     const [Spinner1, setSpinner1] = useState(false)

    //  var curr = new Date();
    //  curr.setDate(curr.getDate() - curr.getDate()+1);
    //  var date = curr.toISOString().substring(0,10);

    //  var curr=new Date()
    //  curr.setDate(curr.getDate())
    //  var date1 = curr.toISOString().substring(0,10);

    const column = useMemo(
        () => [
          {
            Header: "Buyer",
            // accessor:(row=>(<div className='text-start'>{row.buyer}</div>)),
            accessor:'buyer',
            filterable: false,
          },
          {
            Header: "Ship No",
            accessor:(row=>(<div className='text-end'>{row.shipNo}</div>)),
            filterable: false,
          },
          {
            Header: "Ipono",
            accessor:(row=>(<div className='text-end'>{row.ipoNo}</div>)),
            filterable: false,
    
          },
    
          {
            Header: "OrderNo",
            accessor:(row=>(<div className='text-end'>{row.orderNo}</div>)),
            filterable: false,
    
          },
          {
            Header: "Order Date",
            accessor: (row=>(
              (moment(row.orderDt).format("DD-MM-yyyy"))
            )),
            filterable: false,
          },
          {
            Header: "Season",
            accessor: (row=>(<div className='text-start'>{row.season}</div>)),
            filterable: false,
          
          },
          {
            Header: "Style",
            accessor:(row=>(<div className='text-start'>{row.style}</div>)),
            filterable: false,
          
          },
          // {
          //   Header: "ArtNo",
          //   accessor:(row=>(<div className='text-end'>{row.artNo}</div>)),
          //   filterable: false,
           
          // },
          {
            Header: "Garment",
          accessor:(row=>(<div className='text-start'>{row.garment}</div>)),
            filterable: false,
          
          },
          {
            Header: "Country",
          accessor:(row=>(<div className='text-start'>{row.country}</div>)),
            filterable: false,
          
          },
          {
            Header: "Dest",
          accessor:(row=>(<div className='text-start'>{row.dest}</div>)),
            filterable: false,
          
          },
          {
            Header: "ShipMode",
          accessor:(row=>(<div className='text-start'>{row.shipMode}</div>)),
            filterable: false,
          
          },
          {
            Header: "Unit",
          accessor:(row=>(<div className='text-start'>{row.unit}</div>)),
            filterable: false,
          
          },
          {
            Header: "Ship Date",
          accessor:(row=>(
            (moment(row.shipDt).format("DD-MM-yyyy"))
          )),
            filterable: false,
          
          },
          {
            Header: "Shipped Date",
          accessor:(row=>(
            (moment(row.invDt).format("DD-MM-yyyy"))
          )),
            filterable: false,
          
          },
          {
            Header: "Qty(Pcs)",
          accessor:(row=>(<div className='text-end'>{row.qty}</div>)),
            filterable: false,
          },
          {
            Header: "Ship Qty",
          accessor:(row=>(<div className='text-end'>{row.shipQty}</div>)),
            filterable: false,
          },
          // {
          //   Header: "CancelQty",
          // accessor:'cancelQty',
          //   filterable: false,
          
          // },
          // {
          //   Header: "HoldQty",
          // accessor:'holdQty',
          //   filterable: false,
          
          // },
          // {
          //   Header: "ShipQty",
          // accessor:'shipQty',
          //   filterable: false,
          
          // },
          {
            Header: "BalQty",
          accessor:(row=>(<div className='text-end'>{row.balQty}</div>)),
            filterable: false,
          
          },
          {
            Header: "Rate",
          accessor:((row=>(
             <div className='text-end'>{(numeral(row.rate).format("0,0.00"))}</div> 
          ))),
            filterable: false,
          
          },
          {
            Header: "TotalValue",
          accessor:(row=>(<div className='text-end'>{numeral(row.totalValue).format("0,0.00")}</div>)),
            filterable: false,
          },
          {
            Header: "Total Value In INR",
          accessor:(row=>(<div className='text-end'>{numeral(row.valueinINR).format("0,0.00")}</div>

          )),
            filterable: false,
          },

        ]
    )
    const data=shippedorderdata
    // [{
    //     Ipono:"",

    // }]

    const view=async()=>{
      setSpinner1(true)
      await axios.instance.get(`/ShippedOrder/ShippedOrder?buyerId=${buyervalue.value}&style=${stylevalue.value}&OrderType=${ordertypevalue.value}&shipMode=${shipmodevalue.value}&startDate=${fromdate}&endDate=${todate}&companyid=${Companyvalue.value}`)
      .then ((res)=>{
        
        console.log(res.data)
        res.data==""? (setshippedorderdata([]) || setnotfoundpopup(true)) :  setshippedorderdata(res.data)
      })
      setshowTable(true)
      setTimeout(() => {
        setSpinner1(false)
      }, 2000);
      handleDownload()
    }


    const shippedOrdertoExel = () => {
      let shippedOrdertoExeldata = []
      const columns = [
        'Buyer',
        'Ship No',
        'Ipono',
        'OrderNo',
        'Order Date',
        'Season',
        'Style',
        // 'ArtNo',
        'Garment',
        'Country',
        'Dest',
        'ShipMode',
        'Unit',
        'Ship Date',
        'Shipped Date',
        'Qty(Pcs)',
        'Ship Qty',
        'BalQty',
        'Rate',
        'TotalValue',
        'Total Value In INR'
      ]

      data.map((data) => {
          // console.log(data)
          shippedOrdertoExeldata.push({
            'Buyer':data.buyer,
            'ShipNo':data.shipNo.toString(),
            'Ipono':data.ipoNo.toString(),
            'OrderNo':data.orderNo,
            'OrderDate':moment(data.orderDt).format("DD-MM-yyyy"),
            'Season':data.season,
            'Style':data.style,
            // 'ArtNo':data.artNo.toString(),
            'Garment':data.garment,
            'Country':data.country,
            'Dest':data.dest,
            'ShipMode':data.shipMode,
            'Unit':data.unit,
            'Ship Date':moment(data.shipDt).format("DD-MM-yyyy"),
            'ShippedDate':moment(data.invDt).format("DD-MM-yyyy"),
            'Qty(Pcs)':data.qty.toString(),
            'ShipQty':data.shipQty.toString(),
            'BalQty':data.balQty.toString(),
            'Rate':numeral(data.rate.toString()).format("0,0.00"),
            'TotalValue':numeral(data.totalValue.toString()).format("0,0.00"),
            'TotalValueInINR':numeral(data.valueinINR.toString()).format("0,0.00")
          })
      })
 

      const wb = new Xl.Workbook();
      const ws = wb.addWorksheet('Shipped Order'); 
      var headings = wb.createStyle({
          font: {
              bold: true,
              size: 12,
              vertAlign: 'center'
          },
          alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true
          },
          border: {
              left: {
                  style: "thin"
              },
              right: {
                  style: "thin"
              },
              top: {
                  style: "thin"
              },
              bottom: {
                  style: "thin"
              }
          },
          fill: {
              type: 'pattern',
              patternType: 'solid',
              fgColor: '#ddd9c3'
          }
      });

      var headingLeft = wb.createStyle({
        font: {
            bold: false,
            size: 12,
            vertAlign: 'center'
        },
        alignment: {
            horizontal: 'left',
            vertical: 'center',
            wrapText: true
            
        },
        border: {
            left: {
                style: "thin"
            },
            right: {
                style: "thin"
            },
            top: {
                style: "thin"
            },
            bottom: {
                style: "thin"
            }
        }
      })
    var headingRight = wb.createStyle({
      font: {
          bold: false,
          size: 12,
          vertAlign: 'center'
      },
      alignment: {
          horizontal: 'right',
          vertical: 'center',
          wrapText: true
          
      },
      border: {
          left: {
              style: "thin"
          },
          right: {
              style: "thin"
          },
          top: {
              style: "thin"
          },
          bottom: {
              style: "thin"
          }
      }
    })
    

      let headingColumnIndex = 1;
          columns.forEach(heading => {
            ws.column(headingColumnIndex).setWidth(30);
          ws.cell(7, headingColumnIndex++)
              .string(heading).style(headings)
      }); 

      let rowIndex = 8;
      shippedOrdertoExeldata.forEach( record => {
         
          let columnIndex = 1;
          Object.keys(record ).forEach(columnName =>{
          //   console.log(columnName)
             ws.column(columnIndex).setWidth(30);

             columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 15 || columnIndex === 16 || columnIndex === 17 || columnIndex === 18 || columnIndex === 19 || columnIndex === 20 || columnIndex === 21 ?
             ws.cell(rowIndex,columnIndex).style(headingRight) :
             ws.cell(rowIndex,columnIndex).style(headingLeft)

              ws.cell(rowIndex,columnIndex++)
                  .string(record [columnName])
          });
          rowIndex++;
      });

      
    ws.cell(8+shippedOrdertoExeldata.length,1,8+shippedOrdertoExeldata.length,14,true).string('Total').style(headings)
    ws.cell(8+shippedOrdertoExeldata.length, 15 ).string(`${numeral(data.reduce((accumulator, object,) => {
      return accumulator +object.qty  }, 0)).format('0,0.00')}`).style(headingLeft)
    ws.cell(8+shippedOrdertoExeldata.length, 16 ).string(`${numeral(data.reduce((accumulator, object,) => {
      return accumulator +object.shipQty  }, 0)).format('0,0.00')}`).style(headingLeft)
    ws.cell(8+shippedOrdertoExeldata.length, 17 ).string(`${numeral(data.reduce((accumulator, object,) => {
      return accumulator +object.balQty  }, 0)).format('0,0.00')}`).style(headingLeft)
    ws.cell(8+shippedOrdertoExeldata.length, 18 ).string(`${numeral(data.reduce((accumulator, object,) => {
      return accumulator +object.rate }, 0)).format('0,0.00')}`).style(headingLeft)
    ws.cell(8+shippedOrdertoExeldata.length, 19 ).string(`${numeral(data.reduce((accumulator, object,) => {
      return accumulator +object.totalValue  }, 0)).format('0,0.00')}`).style(headingLeft)
    ws.cell(8+shippedOrdertoExeldata.length, 20 ).string(`${numeral(data.reduce((accumulator, object,) => {
      return accumulator +object.valueinINR  }, 0)).format('0,0.00')}`).style(headingLeft)


      ws.row(7).freeze()

      ws.cell(1, 1, 1, 15, true).string('Shipped Order').style(headings);

      ws.cell(3, 1).string('Company').style(headings);
      ws.cell(3, 2).string(Companyvalue.label).style(headings);

      ws.cell(3, 4).string('Buyer').style(headings);
      ws.cell(3, 5).string(buyervalue.label).style(headings);

      ws.cell(3, 7).string('Style No').style(headings);
      ws.cell(3, 8).string(stylevalue.label).style(headings);

      ws.cell(3, 10).string('Order Type').style(headings);
      ws.cell(3, 11).string(ordertypevalue.label).style(headings);

      ws.cell(5, 1).string('Ship Mode').style(headings);
      ws.cell(5, 2).string(shipmodevalue.label).style(headings);
      
      ws.cell(5, 4).string('From Date').style(headings);
      ws.cell(5, 5).string(moment(fromdate).format("DD-MM-yyyy")).style(headings);

      ws.cell(5, 7).string('To Date').style(headings);
      ws.cell(5, 8).string(moment(todate).format("DD-MM-yyyy")).style(headings);

      wb.writeToBuffer().then(function(buffer) {
          //console.log(buffer)
          const data = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
          //console.log(datas)
          FileSaver.saveAs(data,  'ShippedOrder' + ".xlsx")
      });


  }
        
    
   useEffect(()=>{
        company()
        buyer()
        
        var date =  new Date()
      
        var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
       
        var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
        setfromdate(moment(firstday).format('YYYY-MM-DD'))
        settodate(moment(lastday).format('YYYY-MM-DD'))
        setCompanyvalue(JSON.parse(localStorage.getItem('company')))
   },[])

    const company=async()=>{
        await axios.instance.get("CompanyHelp/GetCompany")
        .then((res)=>{

            const data=res.data
            const option=data.map(row=>({
                "label":row.company,
                "value":row.companyId
            }))
            console.log(option,"companyhelp");
            setcompanyhelp(option)  
        }) 
    }

    const buyer=async()=>{
        await axios.instance.get("/BuyerHelp/ShippedBuyerHelp")
        .then((res)=>{
            const data =res.data
            const option=data.map(row=>({
                "label":row.buyer,
                "value":row.buyerId
            }))
            console.log(option,"buyerhelp")
            option.push({"label":"All",
            "value":"0"})
            setbuyerhelp(option)
        })
    }

    const style=async(value)=>{
        await axios.instance.get(`/StyleNoHelp/ShippedOrderStyleHelp?buyerid=${value}`)
        .then((res)=>{
            const data =res.data
            // console.log(res.data)
            
            const option=data.map(row=>({
                "label":row.style,
                 "value":row.style
            }))
            console.log(option,"stylehelp")
            option.push({label:"All",value:"All"})
            setstylehelp(option)
        })
    }

    

    //ShipMode Options
    const ShipModeoption=[
        {label:"Sea",value:"Sea"},
        {label:"Air",value:"Air"},
        {label:"All",value:"All"}
    ]

    //Ordertype Options
    const Ordertypeoption=[
        {label:"Bulk",value:"B"},
        {label:"Sample",value:"S"},
        {label:"All",value:"All"}
    ]

    const handleDownload = async() => {
      const value =   await axios.instance.get(`/ShippedOrder/ShipedOrder?buyers=${buyervalue.label}&companys=${Companyvalue.label}&buyerId=${buyervalue.value}&style=${stylevalue.value}&OrderType=${ordertypevalue.value}&shipMode=${shipmodevalue.value}&startDate=${moment(fromdate).format('YYYY-MM-DD')}&endDate=${moment(todate).format('YYYY-MM-DD')}&companyid=${Companyvalue.value}`, { responseType: 'blob' })
              .then(response => {
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                 // window.open(response.data, '_blank');
              
                 // const link = document.createElement('a');
                 // link.href = url;
                //  link.setAttribute('download', 'Shipped Order.xlsx');
                //  document.body.appendChild(link);
                //  window.open(link)
                //  link.click();
   
                 
              })
            //  window.open(value)
              .catch(error => {
                  console.error('Error downloading Excel file:', error);
              });
      };
      const ExporttoExcelConsolidate = async() => {
        // await  axios.instance.get('/GetDepartmentSalarySummary', { responseType: 'blob'})
             
         // .then((res) => {
            // const xlBlob = new Blob([res.data] ,{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'})
            // FileSaver.saveAs(xlBlob , `${fileName}.xlsx`)
       //         localStorage.setItem('pdf', pdfBlob)
       //const value = BookedOrder;
      //  var date =  new Date()
    
    
       const now = new Date();
      const year = now.getFullYear();
      const month = now.toLocaleString('default', { month: 'long' });
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      //const date =(`${month}_${day}_${year}`)
      const amPm = hours >= 12 ? 'PM' : 'AM';
      const date =(`${month}_${day}_${year}_${hours}_${minutes}_${amPm}`)
      await window.open(`http://103.27.85.36/ExcelFilewebmins/ShippedOrder_${date}.xlsx`)
   // await window.open(`http://192.168.1.2/Wbei/ExcelFile/ShippedOrder_${date}.xlsx`)
          // })
       }
       
    return(

        <React.Fragment>
      <div className="account-pages my-5 pt-5 m-3 pt-sm-5"> 
      <div  style={{justifyContent:'center', alignItems:'center'}}>
          <div>  
            <Backdrop  open={Spinner1} className={classes.backdrop} >
              <Spinner>
                Loading...
              </Spinner>
            </Backdrop> 
          </div>
      </div>
        <Container fluid={true}>    
           <Card style={{backgroundColor:"white"}}>
                <CardBody>
                  <Row>
                    <Col>
                      <Breadcrumb title="Report" breadcrumbItem="Shipped Order" /></Col>
                  </Row>
                    <Row>
                        <Col sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='excompany'>
                                    Company
                                </Label>         
                                {/* <Input id='excompany' name='company' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select 
                                     value={Companyvalue}
                                    onChange={(value) => {
                                        console.log(value.value)
                                        setCompanyvalue(value)
                                        localStorage.setItem('company',JSON.stringify(value))
                                        // Getbuyervaleu(value.value)
                                    }}
                                    options={companyhelp}
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />

                                
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='exbuyer'>
                                    Buyer
                                </Label>         
                                {/* <Input id='exbuyer' name='Buyer' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    value={buyervalue}
                                    name="Buyer"
                                    onChange={(value)=>{
                                        console.log(value.value,"buyervalue")
                                        setbuyervalue(value)
                                        style(value.value)
                                        // bookedorder(value.value)
                                        console.log(value.value,"stylevalue")
                                        setstylevalue({label:"All", value:"All"})
                                        
                                    }}
                                    options={buyerhelp}
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='exstyleno'>
                                    Style No
                                </Label>         
                                {/* <Input id='exstyleno' name='Style No' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    name="Style No"
                                    onChange={(value)=>{
                                        console.log(value.value,"stylevalue")
                                        console.log(value.label,"stylelabel")
                                        setstylevalue(value)
                                    }}
                                    options={stylehelp}
                                    value={stylevalue}
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                /> 
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='exordertype'>
                                    Order Type
                                </Label>         
                                {/* <Input id='exordertype' name=' Order Type' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    name="Order Type" 
                                    id= 'exordertype'
                                    value={ordertypevalue}
                                    options={Ordertypeoption}
                                    onChange={(value)=>{
                                        console.log(value.value,"ordertypevalue")
                                        setordertypevalue(value)
                                    }}
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='exshipmode'>
                                Shipmode
                                </Label>         
                                {/* <Input id='exshipmode' name='Shipmode' type='select'>
                                    <option>--Select--</option>
                                </Input> */}
                                <Select
                                    name="Shipmode" 
                                    id= 'exshipmode'
                                    value={shipmodevalue}
                                    // onChange={setSelectedOption}
                                    options={ShipModeoption}
                                    onChange={(value)=>{
                                        console.log(value.value,"shipmodevalue")
                                        setshipmodevalue(value)
                                    }
                                    }
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={6}> 
                            <FormGroup> 
                                <Label for='exfromdate'>
                                From Date
                                </Label>         
                                <Input id='exfromdate' name='From Date' type='date' 
                                value={fromdate}
                                min={"1900-01-01"} maxLength="4" max={ "9999-12-31" }
                                onChange={(e)=>setfromdate(e.target.value)}/>
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={6}>
                            <FormGroup> 
                                <Label for='extodate'>
                                To Date
                                </Label>         
                                <Input id='extodate' name='To Date' type='date' 
                                value={todate}
                                min={"1900-01-01"} maxLength="4" max={ "9999-12-31" }
                                onChange={(e)=>settodate(e.target.value)}/>
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={6} style={{marginTop:'30px'}}>
                            {/* <Button color='primary' size='md' className="mx-1" onClick={()=>view()} >View</Button>
                            <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47'}}    className="btn btn-sm btn-primary"  onClick={()=>ExporttoExcelConsolidate()}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button> */}
                            <Button size='md' className="mx-1 w-lg" style={{backgroundColor:'#0E21A0',color:'white',fontWeight:'bolder'}} onClick={()=>{view()}}>View</Button>
                          <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47',fontWeight:'bolder'}}    className="btn btn-sm btn-primary w-lg"  onClick={()=>{ExporttoExcelConsolidate()}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button>
                        </Col>
                    
                    </Row>
                    <Row className='mt-3 mb-3'>
                      <Col sm={12} lg={3} md={6}>
                          {/* {shipedorderdata.map((data,index)=>(
                            <p key={index}>Total Value INR :sumBy{data.valueinInr}</p>
                          ))} */}
                          {/* <p ><span className='text-primary'>Total Qty :</span><div>{numeral(totalQty).format("0,0")}</div></p>  */}
                          <FormGroup> 
                                <Label for='exfromdate'>
                                <span className='text-primary'>Total Ship Qty :</span>
                                </Label>         
                                <Input value={numeral(totalQty).format('0,0.00')} id='totqty' name='totqty' type='text' disabled/>
                          </FormGroup>

                      </Col>
                      <Col sm={12} lg={3} md={6}>
                            {/* <p><span className="text-primary" >Total Value INR : </span> <div>{numeral(totalininr).format("0,0.00")}</div></p> */}
                            <FormGroup> 
                                <Label for='exfromdate'>
                                <span className='text-primary'>Total Ship Value INR :</span>
                                </Label>         
                                <Input value={numeral(totalininr).format('0,0.00')} id='totqty' name='totqty' type='text' disabled/>
                            </FormGroup>
                      </Col>
                    </Row>
                    {showTable && (
                    <TableContainer
                        columns={column}
                        data={data}
                        isGlobalFilter={true}
                        //isAddCustomer={true}
                        isAddTableBorderStrap={true}
                        //   handleInvoiceClicks={handleInvoiceClicks}
                    />
                     )} 
                </CardBody>
           </Card>
        </Container>
      </div>
      { notfoundpopup ? (
        <SweetAlert
          title="No Data Found..."
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent:'center',
            alignItems:'center'
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setnotfoundpopup(false);
          }}
        >
        </SweetAlert>
      ):null}
    </React.Fragment>

    );
}


export default ShippedOrder